module.exports = __webpack_public_path__ + "img/mobile-brand.6985c889.webp";